// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__31I-5","error":"Textarea_error__1XxsZ","readonly":"Textarea_readonly__2Rvyu","disabled":"Textarea_disabled__bQQgR"};